import { render } from "./TraspasoCreate.vue?vue&type=template&id=80b75736&scoped=true"
import script from "./TraspasoCreate.vue?vue&type=script&lang=js"
export * from "./TraspasoCreate.vue?vue&type=script&lang=js"

import "./TraspasoCreate.vue?vue&type=style&index=0&id=80b75736&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b75736"]])

export default __exports__